import Typography from '@repo/ui/typography'
import { useEffect } from 'react'

import withTheme from '../../components/hoc/with-theme'
import AuthLayout from '../../components/layouts/auth-layout'
import { SsoLoginForm } from '../../components/pages/login/sso-login-form'

export const ClientLoginPage = () => {
  useEffect(() => {
    document.querySelector('html')?.setAttribute('data-theme', 'client')
  }, [])

  return (
    <AuthLayout text="Bienvenue!" variant="client">
      <div className="mobile:mt-16">
        <Typography variant={'h1'} className="mb-6 mobile:mb-3 mobile:text-white">
          Connexion
        </Typography>
        <SsoLoginForm />
      </div>
    </AuthLayout>
  )
}

export default withTheme(ClientLoginPage, 'client')
